export default{
    data(){
        return{
            integrationsOptions:[
				{
					id: 1,
					name: 'Instagram'
				},
				{
					id: 2,
					name: 'Foursquare'
				},
				{
					id: 3,
					name: 'Behance'
				},
				{
					id: 4,
					name: 'Facebook'
				},
				{
					id: 5,
					name: 'Youtube'
				},
				{
					id: 6,
					name: 'Twitter'
				},
				{
					id: 10,
					name: 'Whatsapp'
				},
				{
					id: 11,
					name: 'Vimeo'
				},
				{
					id: 12,
					name: 'TikTok'
				},
				{
					id: 13,
					name: 'LinkedIn'
				},
				{
					id: 14,
					name: 'Pinterest'
				}
			],
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/apisList.js